import type { LocationQuery, LocationQueryRaw } from 'vue-router'

/**
 * Vue Router's default stringify leaves `:/` unencoded, so absolute BACK_URL
 * like `https://domain/?x=1` breaks `/auth/` path parsing. URLSearchParams
 * encodes `://` and nested `?` safely.
 */
export function stringifyAuthQuery(
  query: LocationQueryRaw | undefined,
): string {
  const params = new URLSearchParams()
  if (!query) return ''
  for (const [key, raw] of Object.entries(query)) {
    if (raw === undefined || raw === null) continue
    const values = Array.isArray(raw) ? raw : [raw]
    for (const value of values) {
      if (value === undefined || value === null) continue
      params.append(key, String(value))
    }
  }
  return params.toString()
}

export function parseAuthQuery(search: string): LocationQuery {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  const query: LocationQuery = {}
  params.forEach((value, key) => {
    const existing = query[key]
    if (existing === undefined) {
      query[key] = value
      return
    }
    if (Array.isArray(existing)) {
      existing.push(value)
      return
    }
    query[key] = [existing, value]
  })
  return query
}
